import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { addResizeObserver } from '../utils/dom/element';
import { PureComponent } from '../component';
import Button from '../Button';
import icons from '../icons';
import Tab from './Tab';
import { tabsClass } from './styles';
import { isRTL } from '../config';
var REDUNDANT = 30;

var Header =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Header, _PureComponent);

  var _super = _createSuper2(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this, props);
    _this.bindInner = void 0;
    _this.bindWrapper = void 0;
    _this.bindScroll = void 0;
    _this.handlePrevClick = void 0;
    _this.handleNextClick = void 0;
    _this.removeObserver = void 0;
    _this.innerElement = void 0;
    _this.scrollElement = void 0;
    _this.ignoreNextCollapse = void 0;
    _this.state = {
      attribute: 0,
      overflow: false
    };
    _this.setPosition = _this.setPosition.bind(_assertThisInitialized(_this));
    _this.bindInner = _this.bindElement.bind(_assertThisInitialized(_this), 'innerElement');
    _this.bindWrapper = _this.bindElement.bind(_assertThisInitialized(_this), 'wrapperElement');
    _this.bindScroll = _this.bindElement.bind(_assertThisInitialized(_this), 'scrollElement');
    _this.renderTab = _this.renderTab.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handlePrevClick = _this.handleMove.bind(_assertThisInitialized(_this), true);
    _this.handleNextClick = _this.handleMove.bind(_assertThisInitialized(_this), false);
    _this.moveToCenter = _this.moveToCenter.bind(_assertThisInitialized(_this));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Header.prototype), "componentDidMount", this).call(this);

      var isVertical = this.props.isVertical;
      this.setPosition(isVertical);
      this.removeObserver = addResizeObserver(this.innerElement, this.handleResize, {
        direction: true,
        timer: 100
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var isVertical = this.props.isVertical;
      this.setPosition(isVertical);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Header.prototype), "componentWillUnmount", this).call(this);

      if (this.removeObserver) {
        this.removeObserver();
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(isVertical) {
      var attributeString = isVertical ? 'Height' : 'Width';
      if (!this.innerElement) return;
      var innerAttribute = this.innerElement["client".concat(attributeString)];
      var scrollAttribute = this.scrollElement["client".concat(attributeString)];
      var domAttribute = this.state.attribute;
      this.setState({
        overflow: scrollAttribute > domAttribute + innerAttribute,
        attributeString: attributeString
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(_entry, _ref) {
      var x = _ref.x,
          y = _ref.y;
      var isVertical = this.props.isVertical;
      var isResize = isVertical ? y : x;
      if (isResize) this.setPosition(isVertical);
    }
  }, {
    key: "bindElement",
    value: function bindElement(name, el) {
      this[name] = el;
    }
  }, {
    key: "handleMove",
    value: function handleMove(lt) {
      var _this$state = this.state,
          attributeString = _this$state.attributeString,
          a = _this$state.attribute;
      var innerAttribute = this.innerElement["client".concat(attributeString)];
      var scrollAttribute = this.scrollElement["client".concat(attributeString)];
      var attribute = a + (lt ? -innerAttribute : innerAttribute);
      if (attribute < 0) attribute = 0;
      if (attribute + innerAttribute > scrollAttribute) attribute = scrollAttribute - innerAttribute;
      if (scrollAttribute <= innerAttribute) attribute = 0;
      this.setState({
        attribute: attribute
      });
    }
  }, {
    key: "moveToCenter",
    value: function moveToCenter(tabRect, last, first) {
      var isVertical = this.props.isVertical;
      var positions = isVertical ? ['top', 'bottom'] : ['left', 'right'];
      var rect = this.innerElement.getBoundingClientRect();
      var d = isRTL() && !isVertical ? -1 : 1;

      if (tabRect[positions[0]] < rect[positions[0]]) {
        this.setState(immer(function (draft) {
          draft.attribute -= (rect[positions[0]] - tabRect[positions[0]] + (first ? 0 : REDUNDANT)) * d;
        }));
      } else if (tabRect[positions[1]] > rect[positions[1]]) {
        this.setState(immer(function (draft) {
          draft.attribute += (tabRect[positions[1]] - rect[positions[1]] - (draft.attribute === 0 ? -30 : 0) + (last ? 0 : REDUNDANT)) * d;
        }));
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(id, isActive) {
      var _this2 = this;

      if (!isActive) {
        if (this.props.onChange) this.props.onChange(id);
        this.ignoreNextCollapse = true;
        setTimeout(function () {
          return _this2.handleCollapse(false);
        }, 200);
      }
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse(e) {
      var _this$props = this.props,
          onCollapse = _this$props.onCollapse,
          collapsed = _this$props.collapsed;
      if (!onCollapse) return;

      if (typeof e === 'boolean') {
        onCollapse(e);
        return;
      }

      if (this.ignoreNextCollapse) {
        this.ignoreNextCollapse = false;
        return;
      }

      onCollapse(!collapsed);
    }
  }, {
    key: "renderTab",
    value: function renderTab(_ref2) {
      var tab = _ref2.tab,
          id = _ref2.id,
          other = _objectWithoutProperties(_ref2, ["tab", "id"]);

      return (
        /*#__PURE__*/
        React.createElement(Tab, Object.assign({}, other, {
          key: id,
          id: id,
          moveToCenter: this.moveToCenter,
          onClick: this.handleClick
        }), tab)
      );
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this3 = this;

      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          tabs = _this$props2.tabs;
      return (
        /*#__PURE__*/
        React.createElement(Button.Group, {
          className: tabsClass('header-button')
        }, tabs.map(function (tab) {
          return (
            /*#__PURE__*/
            React.createElement(Button, {
              key: tab.id,
              onClick: tab.isActive ? undefined : onChange.bind(_this3, tab.id),
              className: tabsClass(tab.isActive && 'button-active'),
              disabled: tab.disabled
            }, tab.tab)
          );
        }))
      );
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var tabs = this.props.tabs;
      return tabs.map(this.renderTab);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          border = _this$props3.border,
          onCollapse = _this$props3.onCollapse,
          collapsed = _this$props3.collapsed,
          isVertical = _this$props3.isVertical,
          tabBarExtraContent = _this$props3.tabBarExtraContent,
          tabBarStyle = _this$props3.tabBarStyle,
          shape = _this$props3.shape,
          hideSplit = _this$props3.hideSplit;
      var _this$state2 = this.state,
          attribute = _this$state2.attribute,
          overflow = _this$state2.overflow;
      var hor = isRTL() ? 'Right' : 'Left';
      var position = isVertical ? 'Top' : hor;
      var showBorder = shape !== 'bordered' && shape !== 'dash' && !hideSplit;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleCollapse,
          className: tabsClass('header'),
          style: tabBarStyle || {}
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindWrapper,
          className: tabsClass('header-tabs')
        }, onCollapse &&
        /*#__PURE__*/
        React.createElement("span", {
          className: tabsClass('indicator', collapsed && 'collapsed')
        }, icons.AngleRight), attribute > 0 &&
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handlePrevClick,
          className: tabsClass('scroll-prev')
        }, icons.AngleLeft),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindInner,
          className: tabsClass('inner')
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindScroll,
          style: _defineProperty({}, "margin".concat(position), -attribute),
          className: tabsClass('scroll')
        }, shape === 'button' ? this.renderButtons() : this.renderTabs())), overflow &&
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleNextClick,
          className: tabsClass('scroll-next')
        }, isVertical ? icons.AngleRight : icons.AngleRight)), tabBarExtraContent &&
        /*#__PURE__*/
        React.createElement("div", {
          className: tabsClass('extra')
        }, tabBarExtraContent), showBorder && shape !== 'button' &&
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            borderColor: border
          },
          className: tabsClass('hr')
        }))
      );
    }
  }]);

  return Header;
}(PureComponent);

export default Header;